import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import { NavBarTab } from "./nav-bar-tab";
import {
  isUserSiteAdmin,
  checkUserAffiliationForPermissions,
} from "../../shared/utilities";
import { useEffect, useState } from "react";

export const NavBarTabs = () => {
  const { isAuthenticated, getAccessTokenSilently, user } = useAuth0();
  const isAdmin = isUserSiteAdmin(user);

  return (
    <div className="nav-bar__tabs">
      <NavBarTab path="/" label="Home" />
      {isAuthenticated && (
        <>
          <NavBarTab path="/profile" label="Profile" />
          <NavBarTab path="/contacts/all" label="Contacts" />
          <NavBarTab path="/content/all" label="Content" />
          <NavBarTab path="/events/all" label="Events" />
          {isAdmin && <NavBarTab path="/admin" label="Admin" />}
        </>
      )}
    </div>
  );
};
